import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=41f0b5d1&scoped=true&"
import script from "./Page4.vue?vue&type=script&lang=js&"
export * from "./Page4.vue?vue&type=script&lang=js&"
import style0 from "./Page4.vue?vue&type=style&index=0&id=41f0b5d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f0b5d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f0b5d1')) {
      api.createRecord('41f0b5d1', component.options)
    } else {
      api.reload('41f0b5d1', component.options)
    }
    module.hot.accept("./Page4.vue?vue&type=template&id=41f0b5d1&scoped=true&", function () {
      api.rerender('41f0b5d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Page4.vue"
export default component.exports